import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getChuanglanTemplateOptions } from '@/service/notification'

const processSingleDataType = ({ data, dataType }) => {
  let list = data
  if (list && !Array.isArray(list)) {
    if (Array.isArray(list.records)) {
      list = list.records
    } else if (Array.isArray(list.data)) {
      list = list.data
    }
  }
  if (!Array.isArray(list)) return []

  if (!dataType || dataType === 'default') {
    return list
  }

  switch (dataType) {
    case 'option':
      return list.map((item) => ({
        id: `${item.value}`,
        value:
          item.label != null && String(item.label).trim() !== ''
            ? String(item.label)
            : String(item.desc || ''),
        desc: item.desc != null ? String(item.desc) : ''
      }))
    default:
      return list
  }
}

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: []
}

export const fetchChuanglanTemplateOptions = createAsyncThunk(
  'chuanglanTemplateOptions/fetchChuanglanTemplateOptions',
  async ({ query = {}, dataType } = {}, { rejectWithValue }) => {
    try {
      const response = await getChuanglanTemplateOptions(query)
      return {
        data: response.data,
        query,
        dataType
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取创蓝短信模板选项失败')
    }
  }
)

const chuanglanTemplateOptionsSlice = createSlice({
  name: 'chuanglanTemplateOptions',
  initialState: defaultState,
  reducers: {
    resetChuanglanTemplateOptionsState: (state) => {
      state.query = {}
      state.data = []
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChuanglanTemplateOptions.pending, (state, action) => {
        state.fetching = true
        state.error = null
        const arg = action.meta?.arg || {}
        state.query = arg.query || {}
        state.data = []
      })
      .addCase(fetchChuanglanTemplateOptions.fulfilled, (state, action) => {
        const { data, dataType, query } = action.payload || {}
        state.fetching = false
        state.error = null
        state.query = query || {}
        state.data = processSingleDataType({ data, dataType })
      })
      .addCase(fetchChuanglanTemplateOptions.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload
        state.data = []
      })
  }
})

export const { resetChuanglanTemplateOptionsState } = chuanglanTemplateOptionsSlice.actions
export default chuanglanTemplateOptionsSlice.reducer
